import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "font-semibold text-3xl mb-10 text-center" }, "Finalizar Pagamento Pix", -1)
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "flex flex-col md:flex-row w-full justify-around" }
const _hoisted_5 = { class: "flex flex-col my-4 gap-4 lg:gap-10 justify-center" }
const _hoisted_6 = { class: "flex flex-col items-center justify-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-xl w-60" }, " Tempo restante para efetuar o pagamento: ", -1)
const _hoisted_8 = {
  key: 0,
  class: "text-6xl font-bold"
}
const _hoisted_9 = {
  key: 1,
  class: "text-6xl font-bold"
}
const _hoisted_10 = { class: "flex flex-col self-center lg:self-start" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-semibold" }, "Detalhes do pedido:", -1)
const _hoisted_12 = { class: "font-semibold text-lg" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Identificação do extrato:", -1)
const _hoisted_14 = { class: "text-sm" }
const _hoisted_15 = { class: "p-10 rounded-lg w-96 shadow shadow-azul-claro flex justify-center self-center" }
const _hoisted_16 = { class: "flex items-center font-semibold" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/LogoIcon.svg",
  class: "w-20"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!

  return (JSON.parse(JSON.stringify(_ctx.pix.id)) != '')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  (_ctx.pix.timer != -1)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(new Date(_ctx.pix.timer * 1000).toISOString().slice(11, 19)), 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_9, "00:00:00"))
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_12, " Valor: " + _toDisplayString(new Intl.NumberFormat("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                      minimumFractionDigits: 2,
                    }).format(JSON.parse(JSON.stringify(_ctx.pix.price)))), 1),
                    _hoisted_13,
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.pix.id), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                (_ctx.blur === true)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "rounded-full bg-azul-claro absolute z-30 self-center text-white w-32 h-32 p-6",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.regenerate && _ctx.regenerate(...args)))
                    }, [
                      _createVNode(_component_Icon, {
                        icon: "grommet-icons:power-reset",
                        class: _normalizeClass([_ctx.restartingQR ? 'animate-loading-spin' : '', "w-full h-full"])
                      }, null, 8, ["class"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_qrcode_vue, {
                  class: _normalizeClass(_ctx.blur ? 'blur-sm' : 'blur-none'),
                  value: JSON.parse(JSON.stringify(_ctx.pix.qrCode)),
                  size: 250,
                  level: "H"
                }, null, 8, ["class", "value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("p", null, " Copyright " + _toDisplayString(new Date().getFullYear()) + " Enerzee - Um mundo de possibilidades - Todos Os Direitos Reservados. ", 1)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}